.treeItemContainer {
  color: var(--color-white);
  display: flex;
  align-items: center;
  gap: var(--gap-regular);

  &.selected {
    color: var(--color-white);
  }
}
